import React from 'react';
import {Button} from "fearless-common-ui";
import {DashLg, PlusLg} from "react-bootstrap-icons";
import AmountSpan from "./AmountSpan";

const iconSize = 20;

interface QuantitySelectorProps {
  increase: () => void;
  decrease: () => void;
  value: number;
}

/**
 * A numeric seat-count selector with increment and decrement controls.
 *
 * Renders the current quantity via {@link AmountSpan} (no decimals, no "Free"
 * label) flanked by two circular icon buttons. The parent component is
 * responsible for keeping `value` within acceptable bounds and implementing
 * `increase` / `decrease`.
 *
 * @param value    - The current seat count to display.
 * @param increase - Called when the user clicks the "+" button.
 * @param decrease - Called when the user clicks the "−" button.
 */
export default function QuantitySelector({ increase, value, decrease }: QuantitySelectorProps) {
  return (
    <div className="d-flex align-items-center justify-content-center gap-4 fw-bold text-xl py-2">
      <Button
        variant="secondary"
        className="border-0 p-0 rounded-circle text-center"
        onClick={decrease}
      >
        <DashLg className="m-1 text-white" size={iconSize} />
      </Button>
      <div className="d-flex align-items-center gap-2">
        <AmountSpan price={{ unit_amount: value * 100 }} decimals={0} freeSpan={false} />
        <b>seats</b>
      </div>
      <Button variant="secondary" className="border-0 p-0 rounded-circle" onClick={increase}>
        <PlusLg className="m-1 text-white" size={iconSize}/>
      </Button>
    </div>
  );
}
